export enum COLUMN_DATA_TYPE_ENUM {
  PERCENT = "percent",
  CURRENCY = "currency",
  INT = "int",
}
